import BTResendEmail from '@/components/bt-resendemail/BT-ResendEmail'
import test from '@/components/dialogs/DataTrailHistory'

const BTResendEmailRouter = [
  {
    path: '/BT-resendemail',
    name: 'business-trip-resend-email',
    component: BTResendEmail
  },
  {
    path: '/test',
    name: 'test',
    component: test
  }
]

export default BTResendEmailRouter



// WEBPACK FOOTER //
// ./src/router/BusinessTripResendEmail.js